import React, { useEffect, useEffectEvent, useState } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router'
import { SectionName } from '_gql'

import { FormattedMessage } from '@divvy-web/i18n'
import CollapsibleList from '@divvy-web/skylab.collapsiblelist'
import { NavigationLink } from '@divvy-web/skylab.mainnavigation'

import useGetCreditAppTypes from '@sputnik/hooks/useGetCreditAppTypes'
import ApplicationProgress from '@sputnik/pages/CreditApplicationPages/Navigation/ApplicationProgress'
import { useApplicationProgress } from '@sputnik/pages/CreditApplicationPages/Navigation/useApplicationProgress'
import { PATHNAME_CONSTS } from '@sputnik/resources/constants'
import { useWebTracking } from '@sputnik/tracking/WebTrackingContext'

const FinancialInfoNavSection = () => {
  const { appId } = useParams()
  const { pathname } = useLocation()
  const navigate = useNavigate()
  const { track } = useWebTracking()
  const { isMajorAccountChange, isMigration, isLoadingCreditAppTypes } = useGetCreditAppTypes({
    salesforceCreditId: appId ?? '',
  })

  const completionStatus = useApplicationProgress({ sectionName: SectionName.FINANCE_INFO })

  const isPathnameFinancialDetails = pathname.includes(PATHNAME_CONSTS.FINANCIAL_DETAILS_PATH)
  const isPathnameConnectBankAccount = pathname.includes(PATHNAME_CONSTS.CONNECT_BANK_ACCOUNT_PATH)
  const isFinancialInfoSectionActive = isPathnameFinancialDetails || isPathnameConnectBankAccount

  const [isMenuOpen, setIsMenuOpen] = useState(isFinancialInfoSectionActive)
  const onPathChange = useEffectEvent((isOpen: boolean) => {
    setIsMenuOpen(isOpen)
  })
  useEffect(() => {
    onPathChange(isPathnameFinancialDetails || isPathnameConnectBankAccount)
  }, [pathname, isPathnameFinancialDetails, isPathnameConnectBankAccount])

  if (isLoadingCreditAppTypes || isMigration || isMajorAccountChange) {
    return null
  }

  return (
    <div onClickCapture={() => setIsMenuOpen((prev) => !prev)}>
      <CollapsibleList
        header={
          <NavigationLink
            icon={<ApplicationProgress status={completionStatus} />}
            label={
              <FormattedMessage
                defaultMessage='Financial info'
                id='sputnik.FinancialInfoNavSection__YVlBeJ'
              />
            }
          />
        }
        menuIsOpen={isMenuOpen}
      >
        <NavigationLink
          dataTestId='financial-details-navigation-link'
          isActive={isPathnameFinancialDetails}
          isExact={isPathnameFinancialDetails}
          label={
            <FormattedMessage
              defaultMessage='Financial details'
              id='sputnik.FinancialInfoNavSection__LMvFSU'
            />
          }
          onClick={() => {
            track('se_signup__left_nav_menu_section_change__fired', {
              navigated_to_page: PATHNAME_CONSTS.FINANCIAL_DETAILS_PATH,
            })
            navigate({ pathname: PATHNAME_CONSTS.FINANCIAL_DETAILS_PATH }, { replace: true })
          }}
        />
        <NavigationLink
          dataTestId='connect-bank-account-navigation-link'
          isActive={isPathnameConnectBankAccount}
          isExact={isPathnameConnectBankAccount}
          label={
            <FormattedMessage
              defaultMessage='Connect bank account'
              id='sputnik.FinancialInfoNavSection__pRTJkh'
            />
          }
          onClick={() => {
            track('se_signup__left_nav_menu_section_change__fired', {
              navigated_to_page: PATHNAME_CONSTS.CONNECT_BANK_ACCOUNT_PATH,
            })
            navigate({ pathname: PATHNAME_CONSTS.CONNECT_BANK_ACCOUNT_PATH }, { replace: true })
          }}
        />
      </CollapsibleList>
    </div>
  )
}

export default FinancialInfoNavSection
